<template>
  <div class="date">
    <datetimePicker :closeOnClickModal="false" v-model="value" @confirm="handleConfirm" @cancel="checkinCancel" cancelText="取消" confirmText="确定" ref="datePicker" type="date" :visibleItemCount="3" :isNeedDay='isNeedDay' :endDate='endDate' year-format="{value} 年" month-format="{value} 月" date-format="{value} 日">
    </datetimePicker>
  </div>
</template>
<script>
import datetimePicker from "../common/datetimePicker";
export default {
  components: {
    datetimePicker
  },
  props: {
    // 是否展示 model
    showModel: {
      type: Boolean,
      default: false
    },
    // 是否展示 model //如果为false 不展示日，但是日还是默认是 1 日的
    isNeedDay: {
      type: Boolean,
      default: true
    },
    // 传过来的时间
    dateValue: {
      type: [Date],
      default: new Date()
    },
    //日期的最大可选值
    endDate: {
      type: [Date],
      default: new Date(new Date(new Date().getTime() - 24 * 60 * 60 * 1000 * 1))
    },
    //日期的最小可选值
    startDate: {
      type: [Date],
      default() {
        return new Date(new Date().getFullYear() - 10, 0, 1);
      }
    }
  },
  data() {
    return {
      value: this.dateValue,
      // startDate: new Date(), //  日期的最小可选值
    };
  },
  watch: {
    showModel(value) {
      if (value) {
        this.openPicker();
      } else {
        this.checkinCancel();
      }
    }
  },
  methods: {
    checkinCancel() {
      // console.log('cancel')
      this.$refs.datePicker.close();
      this.$emit("hide", 2);
    },
    handleConfirm(date) {
      // console.log("date:", date);
      this.$refs.datePicker.close();
      this.submit(date)
    },
    // 提交
    submit(date) {
      this.$emit("ok", date);
    },
    openPicker() {
      this.$refs.datePicker.open();
    },
  },
  created() {},
  mounted() {}
};

</script>
<style lang="less" >
.date {
  .mint-popup {
    z-index: 99999999!important;
    border-radius: 0;
  }
  .mint-datetime-cancel {
    color: #e2e2e2;
  }
}

</style>



// WEBPACK FOOTER //
// src/components/app/appUsage/appModelDate.vue